module.exports = __webpack_public_path__ + "img/QDlogo.fe687a48.png";